import { useEffect } from "react";

import { buttonClass } from "./components/buttonClass";
import { EmptyState } from "./components/Feedback";
import { AuditDashboard } from "./features/freightAudit/AuditDashboard";
import { AuditHistory } from "./features/freightAudit/AuditHistory";
import { NewAuditWizard } from "./features/freightAudit/NewAuditWizard";
import { matchRoute, useLocation } from "./hooks/router";
import { Link } from "./components/Link";

const TITLES = { new: "New audit", history: "Audit history", audit: "Audit results", notFound: "Not found" } as const;

function Logo() {
  return (
    <svg className="brand__logo" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M7 11.5 16 7l9 4.5v9L16 25l-9-4.5z" />
      <path d="M7 11.5 16 16l9-4.5M16 16v9" />
    </svg>
  );
}

export function App() {
  const { path } = useLocation();
  const route = matchRoute(path);

  useEffect(() => {
    document.title = `${TITLES[route.name]} · FreightAudit · OpsCrate`;
  }, [route.name]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="topbar">
        <div className="topbar__inner">
          <Link to="/" className="brand" aria-label="OpsCrate FreightAudit, new audit">
            <Logo />
            <span className="brand__crate">OpsCrate</span>
            <span className="brand__divider" aria-hidden="true">
              /
            </span>
            <span className="brand__tool">FreightAudit</span>
          </Link>
          <nav className="topnav" aria-label="Main">
            <Link to="/" aria-current={route.name === "new" ? "page" : undefined}>
              New audit
            </Link>
            <Link to="/audits" aria-current={route.name === "history" || route.name === "audit" ? "page" : undefined}>
              History
            </Link>
          </nav>
        </div>
      </header>
      <main id="main" className="page" tabIndex={-1}>
        {route.name === "new" ? <NewAuditWizard /> : null}
        {route.name === "history" ? <AuditHistory /> : null}
        {route.name === "audit" ? <AuditDashboard key={route.auditId} auditId={route.auditId} /> : null}
        {route.name === "notFound" ? (
          <EmptyState
            title="That page doesn't exist."
            action={
              <Link to="/" className={buttonClass("primary")}>
                Start a new audit
              </Link>
            }
          />
        ) : null}
      </main>
      <footer className="footer">
        <p>
          <strong>OpsCrate</strong> · Small tools for expensive operational friction.
        </p>
        <p className="muted">Flags are exceptions for operator review, not confirmed overcharges.</p>
      </footer>
    </>
  );
}
